<template>
    <div>
         <v-form ref="form" class="p-2">
           <v-row dense>
                <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <v-text-field
                        v-model="item.codigo"
                        outlined
                        dense
                        :class="$css_field"
                        clearable
                        :counter="7"
                        maxlength="7"
                        autofocus
                        @keydown.enter="validate"
                    >
                        <template v-slot:label>
                            <span :class="$css_field">Código</span>
                        </template>
                    </v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <v-btn
                        color="primary"
                        @click="validate"
                        :class="$css_button"
                    >
                        <span>Adicionar</span>
                    </v-btn>
                </v-col>  
            </v-row>
        </v-form> 

        <div>
                <v-card
                    class="mx-auto"
                    outlined
                >
                    <v-data-table
                        :hide-default-header="$vuetify.breakpoint.xsOnly"
                        :headers="headers"
                        :items="properties"
                        :items-per-page="10"
                        class="elevation-1 table-striped"
                        :footer-props="{
                        'items-per-page-text':'Itens por página',
                        'items-per-page-options': [5, 10],
                        'items-per-page-all-text': '',
                        'page-text': '{0}-{1} de {2}'
                    }"
                    >   
                        <template v-slot:[`item.description`]="{ item }">
                           <v-row class="pa-1">
                                <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                    <slide-single :items="item.photos_total" class="ma-1" />
                                </v-col>
                                <v-col cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                    <v-row dense>
                                        <!-- Codigo e datas -->
                                        <v-col cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                                <span>
                                                    <v-chip
                                                        color="blue"
                                                        label
                                                        text-color="white"
                                                        class="font-weight-medium text-h7"
                                                    >
                                                    COD: {{ item.codigo }} 
                                                    </v-chip>   
                                                </span>
                                                <span class="ml-2">
                                                    <v-chip
                                                        :color="item.status | statusProperty"
                                                        label
                                                        text-color="black"
                                                        class="font-weight-medium text-h7"
                                                    >
                                                        {{ item.status }}
                                                    </v-chip> 
                                                </span>
                                                <span class="ml-2 text-h7 black--text font-weight-medium">
                                                    {{ item.tipo_imovel }}
                                                    <span v-if="item.tipo_imovel == 'Conjunto'"> {{ item.finalidade }}</span> 
                                                    <span v-if="(showSubTipoImovel(item) != '')"> 
                                                        ( {{showSubTipoImovel(item)}} )
                                                    </span> 
                                                </span>
                                                <span class="ml-2 text-h7 black--text font-weight-medium">  
                                                    DT. Inclusão: 
                                                    <span v-if="item.property_relation_created_at"> {{ formatDate(item.property_relation_created_at) }}</span>
                                                </span>   
                                        </v-col>  
                                    </v-row>
                                    <!-- Fim codigo e datas -->


                                    <!-- endereco -->
                                    <v-row dense>
                                        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" style="min-height: 70px;">
                                            <div :class="$vuetify.breakpoint.smAndDown ? 'text-subtitle-2 font-weight-light black--text' : 'text-subtitle-1 font-weight-light black--text'">
                                                {{ item.endereco }}
                                                <span v-if="item.numero">, {{ item.numero }} </span>
                                                <span v-if="item.apartamento"> - Apto: {{ item.apartamento }} </span>
                                                <span v-if="item.andar">  - {{ item.andar }} andar </span>
                                                <span v-if="item.tower && item.tower.nome != ''"> - Torre: {{ item.tower.nome }} </span>
                                                <span v-if="item.complemento"> - Compl: {{ item.complemento }} </span>
                                                <span v-if="item.bairro">  - {{ item.bairro }} </span>
                                                <span v-if="item.cidade">  - {{ item.cidade }} </span>
                                                <span v-if="item.estado">  - {{ item.estado }} </span>
                                                <span v-if="item.cep">  - {{ item.cep | VMask('#####-###') }} </span>
                                            </div> 
                                        </v-col>                                        
                                    </v-row>  
                                    <!-- fim endereco -->

                                    <!-- dados principais buttons -->
                                    <v-row dense>
                                        <v-col cols="auto" v-if="item.area">
                                            <v-chip
                                                :small="$vuetify.breakpoint.smAndDown"
                                                label
                                                outlined
                                                color="black"
                                                dark
                                                block
                                            >
                                                <span>{{ item.tipo_imovel | labelArea('area') }} {{ item.area }} m²</span> 
                                            </v-chip>
                                        </v-col>
                                        <v-col cols="auto" v-if="item.area_total">
                                            <v-chip
                                                :small="$vuetify.breakpoint.smAndDown"
                                                label
                                                outlined
                                                color="black"
                                                dark
                                            >
                                                <span>{{ item.tipo_imovel | labelArea('area_total') }} {{ item.area_total }} m²</span> 
                                            </v-chip>
                                        </v-col>
                                        <v-col cols="auto" v-if="item.area_construida_terreno">
                                            <v-chip
                                                :small="$vuetify.breakpoint.smAndDown"
                                                label
                                                outlined
                                                color="black"
                                                dark
                                            >
                                                <span>A. const. terr. {{ item.area_construida_terreno }} m²</span> 
                                            </v-chip>
                                        </v-col>
                                        <v-col cols="auto" v-if="item.dormitorios">
                                            <v-chip
                                                :small="$vuetify.breakpoint.smAndDown"
                                                label 
                                                outlined
                                                color="black"
                                                dark
                                            >
                                            <span>{{ item.dormitorios }} dorm(s)</span> 
                                            </v-chip>
                                        </v-col>
                                        <v-col cols="auto" v-if="item.suites">
                                            <v-chip
                                                :small="$vuetify.breakpoint.smAndDown"
                                                label
                                                outlined
                                                color="black"
                                                dark
                                            >
                                            <span>{{ item.suites }} suite(s)</span> 
                                            </v-chip>
                                        </v-col>
                                        <v-col cols="auto" v-if="item.banheiros">
                                            <v-chip
                                                :small="$vuetify.breakpoint.smAndDown"
                                                label
                                                outlined
                                                color="black"
                                                dark
                                            >
                                            <span>{{ item.banheiros }} banheiro(s)</span> 
                                            </v-chip>
                                        </v-col>
                                        <v-col cols="auto" v-if="item.vagas">
                                            <v-chip
                                                :small="$vuetify.breakpoint.smAndDown"
                                                label
                                                outlined
                                                color="black"
                                                dark
                                            >
                                            <span>{{ item.vagas }} vaga(s)</span> 
                                            </v-chip>
                                        </v-col> 
                                    </v-row>  
                                    <!-- fim dados principais buttons -->  


                                    <!-- valores -->
                                    <v-row dense>
                                        <v-col cols="auto" v-if="item.valor_venda && item.valor_venda > 0" :class="$vuetify.breakpoint.smAndDown ? 'text-subtitle-2 black--text' : 'text-h6 black--text'">
                                            Venda {{ item.valor_venda | toCurrency }}
                                        </v-col> 
                                        <v-col cols="auto" v-if="item.valor_locacao && item.valor_locacao > 0" :class="$vuetify.breakpoint.smAndDown ? 'text-subtitle-2 black--text' : 'text-h6 black--text'">
                                            Locaçāo {{ item.valor_locacao | toCurrency }}
                                        </v-col>
                                        <v-col cols="auto" v-if="item.valor_condominio && item.valor_condominio > 0" :class="$vuetify.breakpoint.smAndDown ? 'font-weight-light black--text' : 'mt-1 font-weight-light black--text'">
                                            Cond. {{ item.valor_condominio | toCurrency }}
                                        </v-col>
                                        <v-col cols="auto" v-if="item.valor_iptu && item.valor_iptu > 0" :class="$vuetify.breakpoint.smAndDown ? 'font-weight-light black--text' : 'mt-1 font-weight-light black--text'">
                                            IPTU {{ item.valor_iptu | toCurrency }}
                                        </v-col> 
                                        <v-col cols="auto" v-if="item.valor_locacao && item.valor_locacao > 0" :class="$vuetify.breakpoint.smAndDown ? 'font-weight-light black--text' : 'mt-1 font-weight-light black--text'">
                                            Total {{ setTotal(item) | toCurrency }}
                                        </v-col>  
                                    </v-row>
                                    <!-- fim valores -->

                                    <v-row
                                        dense
                                        class="text-right"
                                    >
                                        <v-col cols="auto">
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn 
                                                        v-bind="attrs" v-on="on" 
                                                        :class="$css_button" 
                                                        :small="$vuetify.breakpoint.smAndDown" 
                                                        depressed 
                                                        outlined 
                                                        @click.prevent="showItem(item.id)"
                                                    >
                                                        <v-icon left>mdi-eye</v-icon> Ficha
                                                    </v-btn>
                                                </template>
                                                <span>Visualizar Ficha</span>
                                            </v-tooltip>
                                        </v-col>
                                        <v-col cols="auto">
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn 
                                                        v-bind="attrs" v-on="on" 
                                                        :class="$css_button" 
                                                        :small="$vuetify.breakpoint.smAndDown" 
                                                        depressed 
                                                        outlined 
                                                        @click.prevent="destroy(item.property_relation_id)"
                                                    >
                                                        <v-icon left>mdi-delete</v-icon> Excluir
                                                    </v-btn>
                                                </template>
                                                <span>Excluir</span>
                                            </v-tooltip>
                                        </v-col> 
                                    </v-row>
                                </v-col>
                            </v-row>
                        </template>
                    </v-data-table>
                </v-card>
        </div> 


        <!-- Dialog -->
        <v-dialog 
            v-if="property && property != ''"
            v-model="dialog.show" 
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
        >
            <v-system-bar
                dark
                color="primary"
                height="10px"
            >    
            </v-system-bar>    

            <v-card class="d-print-none background" >
                <v-card-title class="text-h5">
                    <span v-if="property.codigo">Código {{property.codigo}} - {{ property.tipo_imovel }} <span v-if="property.sub_tipo_imovel"> ({{ property.sub_tipo_imovel }})</span> </span>
                    <v-spacer></v-spacer>
                    
                    <button-share-component class="mr-4" :object="property"></button-share-component>
                    
                    <v-btn icon @click="openCloseDialog('show')">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-divider></v-divider>
                <v-container>
                    <v-row>
                        <v-col cols="12">
                            <property-show :object="property" />   
                        </v-col>
                    </v-row>     
                </v-container>
            </v-card>   
        </v-dialog>
        <!-- End Dialog -->

    </div>
</template>

<script>
import PropertyShow from '@/components/properties2/PropertyShow.vue';
import ButtonShareComponent from '@/components/button_share/ButtonShareComponent.vue'
import AlertComponent from '@/components/alert/AlertComponent.vue'
import SlideSingle from '@/components/slideshow/SlideSingle.vue';

export default {
    components: {
        ButtonShareComponent,
        AlertComponent,
        PropertyShow,
        SlideSingle
    },

    props: {
        object: {
            require: true,
        },
    },

    watch: {
        object: {
            handler() {
                this.setObject();           // ← configura o formulário com os dados
            },
            immediate: true // ← garante que execute mesmo se já estiver definido
        },
    },

    computed: {
        me () {
          return this.$store.state.auth.me
        },
    }, 

    data () {
        return {
            properties: [],

            alerts: {
                limit: {
                    type: 'error',
                    icon: 'mdi-alert-outline',
                    messages: ['Você atingiu o limite de imóveis para essa vitrine. Voce poderá cadastrar imoveis em outra vitrine se desejar. Procure evitar de acrescentar muitas informações na pagina inicial para nāo comprometer a rapidez do site. ']
                },
            },

            register: true,

            permissions: {
                store_property: true,
                active_property: true,
                update_active_property: true,
                view_owners_others: true,
                colaborator: true
            },

            property: {},

            dialog: {
                show: false
            },

            item: {},

            rules: {
                required: value => !!value || 'Required.',
            },

            headers: [
                { text: 'DESCRIÇĀO', align: 'start', value: 'description', },
            ],
        }
    },

    methods:{ 
        setObject(){
            const result = this.object.items;
            this.properties = result.sort((a, b) => new Date(a.property_relation_created_at) - new Date(b.property_relation_created_at));
        },


        showItem (id) {    
            this.$store.dispatch('loadProperty', id) 
                        .then(response => {
                            this.property = response.data
                            this.dialog.show = true
                        })
                                   
        },
        
        validate () {
            if (this.$refs.form.validate()) {       
                this.store()
            }
        },
        
        store(){
            const index = this.properties.findIndex(c => c.codigo === this.item.codigo);
            if(index == -1){
                this.item.model = this.object.model
                this.item.item_id = this.object.item_id
                this.$store.dispatch('storePropertyRelation', this.item)
                            .then(response => {
                                const result = response.data
                                this.properties.push(result);
                                this.reset();
                            })
                            .catch(error => {   
                                this.$snotify.error('Erro no cadastro');
                            })
            }  else {
                this.$snotify.error('O codigo '+ this.item.codigo +' já foi adicionado.');
            }                       
        },

        reset(){
            this.item = {}
            this.$refs.form.reset()
        },

        destroy(id){
            this.$store.dispatch('destroyPropertyRelation', id)
                        .then(response => {
                            const index = this.properties.findIndex(c => c.property_relation_id === id);
                            this.properties.splice(index, 1);
                        })
                        .catch(error => {
                            this.$snotify.error('Erro no cadastro')
                        })
                        .finally(
                            //this.$snotify.remove()
                            this.$snotify.success('Registro excluído com sucesso!')
                        )
        },

        loadUsers(){
            this.$store.dispatch('loadUsers')
        },

        openCloseDialog(window){
            if(window == 'show'){
                this.dialog.show = !this.dialog.show 
            }
        },

    }    
}
</script>